import { BehaviorSubject } from 'rxjs';
import scrollLock from 'scroll-lock';
var AbstractModalContentComponent = /** @class */ (function () {
    function AbstractModalContentComponent(modalService) {
        this.modalService = modalService;
        this.TYPE = '';
        this.htmlElement = document.getElementsByTagName('html');
        this.dataSubscriber = new BehaviorSubject(null);
        //this.htmlElement[0].classList.add('no-scroll');
        scrollLock.hide();
    }
    Object.defineProperty(AbstractModalContentComponent.prototype, "data", {
        get: function () { return this.dataSubscriber.getValue(); },
        set: function (val) { this.dataSubscriber.next(val); },
        enumerable: true,
        configurable: true
    });
    AbstractModalContentComponent.prototype.closeModal = function () {
        this.modalService.close();
        this.htmlElement[0].classList.remove('no-scroll');
        scrollLock.show();
        if (this.destroy)
            this.destroy();
    };
    AbstractModalContentComponent.prototype.ngAfterContentChecked = function () {
        /* 	if (!this.htmlElement[0].classList.contains('no-scroll')) {
                this.htmlElement[0].classList.add('no-scroll');
                scrollLock.hide();
            } */
    };
    return AbstractModalContentComponent;
}());
export { AbstractModalContentComponent };
